import { FormattedNumber } from 'i18n'

export const getTotalPrice = item => {
    if (item && item.rate && item.rate.amount != null) {
        const promoCodeDiscount = item.promoCode ? item.promoCode.promoDiscount : 0
        const price = item.rate.amount - promoCodeDiscount

        return price >= 0 ? price : 0
    }
    return null
}

export const sumCalculator = (items, prop) => items.reduce((a, b) => a + (b[prop] || 0), 0)

export const RateCurrency = ({ rate, value, currency, fractionDigits, className, id }) => (
    <span id={id || ''} className={className || ''}>
        {currency || rate?.currencySymbol}
        <FormattedNumber
            value={value}
            minimumFractionDigits={fractionDigits || 2}
            maximumFractionDigits={fractionDigits || 2}
        />
    </span>
)
